module.exports = __webpack_public_path__ + "img/background.05da97e6.jpg";